import { render, staticRenderFns } from "./my-follow.vue?vue&type=template&id=1835d588&scoped=true"
import script from "./my-follow.vue?vue&type=script&lang=js"
export * from "./my-follow.vue?vue&type=script&lang=js"
import style0 from "./my-follow.vue?vue&type=style&index=0&id=1835d588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1835d588",
  null
  
)

export default component.exports